/** Fenêtre « proche » alignée sur l’export admin (identity_expires_month). */
export const IDENTITY_EXPIRY_SOON_DAYS = 30;

/**
 * @returns {'missing'|'expired'|'soon'|'ok'}
 */
export function getIdentityExpiryStatus(user) {
  const expiry = user?.identity?.expiryDate;
  if (!expiry) return 'missing';

  const expiryDate = new Date(expiry);
  if (Number.isNaN(expiryDate.getTime())) return 'missing';

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);
  const daysUntil = Math.round((expiryDate - today) / (24 * 60 * 60 * 1000));

  if (expiryDate < today) return 'expired';
  if (daysUntil <= IDENTITY_EXPIRY_SOON_DAYS) return 'soon';
  return 'ok';
}

/** Pièce d'identité échue (date d'expiration strictement avant aujourd'hui). */
export function isIdentityExpired(user) {
  const expiry = user?.identity?.expiryDate;
  if (!expiry) return false;

  const expiryDate = new Date(expiry);
  if (Number.isNaN(expiryDate.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);
  return expiryDate < today;
}

/** Commande d'un seul billet au nom du membre (billet titulaire). */
export function orderIncludesPrimaryTicket(showPrimaryTicket, orderQuantity) {
  return showPrimaryTicket && orderQuantity === 1;
}
